
// Re-export from the refactored files
import AuthContext, { useAuthContext, AuthContextType } from './context/AuthContext';
import { AuthProvider } from './providers/AuthProvider';
import { AuthUser } from './types/AuthTypes';

export {
  AuthContext,
  useAuthContext,
  AuthProvider as UltraSimpleAuthProvider,
  type AuthContextType,
  type AuthUser
};

// Add a console log to debug when this module is loaded
console.log("[UltraSimpleAuthContext] Module loaded and ready to be used");
